/* eslint-disable jsx-a11y/anchor-is-valid */
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {KTableProvider} from '../../../../../../contexts/KTableProvider'
import {useCentral} from '../../../../../../hooks/useCentral'
import {MasiveUploadPerson} from '../form/masive'
import {TablePerson} from './ColumnsPerson'

const TablePersonWrapper = () => {
  const {isAllowed} = useCentral()
  return (
    <KTableProvider>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Listado de Personas</Tab>
            {isAllowed('MASIVO') && <Tab className={'sdx_sub_tab_panel_option'}>Carga Masiva</Tab>}
          </TabList>
          <TabPanel>
            <TablePerson />
          </TabPanel>
          {isAllowed('MASIVO') && (
            <TabPanel>
              <MasiveUploadPerson />
            </TabPanel>
          )}
        </Tabs>
      </div>
    </KTableProvider>
  )
}

export {TablePersonWrapper}
